import React, { Component } from 'react'
import Checkbox from '@material-ui/core/Checkbox';

export default class TodoItem extends Component {
    render() {
        const {title, completedDate, isChecked, handleChecked, handleEdit, handleDelete, handleCompleted} = this.props

        return (
            <li className="list-group-item text-capitalize d-flex justify-content-between my-2">
                <Checkbox
                    name={title}
                    checked={isChecked}
                    onChange={handleChecked}
                    value="primary"
                    color="secondary"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                />
                <div id="todo-item">
                    <div id={completedDate !== "" ? "todo-item-text-completed" : "todo-item-text"}>{title}</div>
                    <div id="todo-item-completedDT">{completedDate}</div>
                </div>
                <div className="todo-icon">
                    <span className="mx-2 text-success item-actions edit" onClick={handleEdit}>
                        <i className="fas fa-pen faa-pen"></i>
                    </span>
                    <span className="mx-2 text-danger item-actions delete" onClick={handleDelete}>
                        <i className="fas fa-trash"></i>
                    </span>
                    <span className={completedDate !== "" ? "mx-2 text-success item-actions check" : "mx-2 text-primary item-actions check"} onClick={handleCompleted}>
                        <i className="fas fa-check"></i>
                    </span>
                </div>
            </li>
        )
    }
}